import RevolverModel from "slotworks/integration/revolver/model/revolver-model";
import { ResultsAndDetail } from "slotworks/integration/revolver/schema/spin-record-schema";
import Record from "slotworks/model/gameplay/records/record";
import LineResult from "slotworks/model/gameplay/records/results/line-result";
import Result from "slotworks/model/gameplay/records/results/result";
import { ResultBuilder } from "slotworks/server/builders/result-builder";
import SymbolModel from "slotworks/server/symbols/symbol-model";
import WayResult from "./way-result";

class WayResultBuilder implements ResultBuilder {

    public filter(data: any): boolean {
        const resultsAndDetail = data as ResultsAndDetail;

        if (!resultsAndDetail) {
            return false;
        }

        const detail = resultsAndDetail.detail;

        return detail && detail.type && detail.type === "$WAY";
    }

    public build(record: Record, data: any): Result[] {
        const resultsAndDetail = data as ResultsAndDetail;
        const detail = resultsAndDetail.detail;

        const result = new WayResult();
        result.creditsWon = detail.cash;
        result.matches = detail.oak;
        result.symbolType = SymbolModel.convertSymbolToSlotworks(detail.symbol);
        result.freespinsWon = 0;
        result.line = 1;

        result.positions = RevolverModel.convertPositionsToGridPositions(detail.positions);

        return [result];
    }
}

export default new WayResultBuilder();



// WEBPACK FOOTER //
// ./~/ifdef-loader/ifdef-loader.js??ref--0-1!./src/integration/builders/way-result-builder.ts